import { styled } from '../../lib/styles';
import { DateMarker } from '../../components/DateMarker';
import { jsx as _jsx } from "react/jsx-runtime";
export const AbsoluteWrapper = styled.div.withConfig({
  displayName: "DayCalendarStyles__AbsoluteWrapper",
  componentId: "a9ww32-0"
})(["width:100%;height:100%;position:relative;"]);
export const Event = styled.div.attrs(({
  length,
  minute
}) => ({
  'data-test-id': 'day-calendar-event',
  'data-length': length,
  'data-minute': minute
}))(({
  theme: {
    uiAddonCalendars: {
      dayView: {
        hourHeight
      },
      eventMargin,
      util: {
        eventWidth
      }
    }
  },
  length,
  hour,
  minute = 0,
  index,
  totalEvents
}) => `
  margin-left: ${eventMargin};
  margin-right: ${eventMargin};
  overflow: hidden;
  height: calc((${hourHeight} * ${length}) - ${eventMargin})});
  left: ${100 / totalEvents * index}%;
  position: absolute;
  margin-top: ${eventMargin};
  margin-bottom: ${eventMargin};
  top: calc(${hourHeight} * ${hour + minute / 60});
  width: ${eventWidth({
  totalEvents,
  lastChild: true
})};
  z-index: 1;

  &:not(:last-child) {
    margin-right: 0;
    width: ${eventWidth({
  totalEvents
})};
  }
`);
export const DayOfWeekText = ({
  children,
  isCurrentDay
}) => /*#__PURE__*/_jsx(DateMarker, {
  isCurrentDay: isCurrentDay,
  size: "24px",
  children: children
});